module.exports = __webpack_public_path__ + "img/img55.12ba7ec9.svg";